import React, { PureComponent } from 'react';
import type { WrappedComponentProps } from 'react-intl';
import { defineMessages, injectIntl } from 'react-intl';

import Button from '@atlaskit/button/button';

import { EmptyStateWrapper } from './EmptyStateWrapper.tsx';
import emptyImage from './Empty.svg';

const i18n = defineMessages({
	header: {
		id: 'template-list.empty.headline',
		defaultMessage: 'We’re fresh out of templates',
		description:
			'This is the headline that shows when the user’s selected space does not have any available templates',
	},
	description: {
		id: 'template-list.empty.description',
		defaultMessage:
			'There aren’t any templates in this space, but there are still lots of way to make your pages pop.',
		description:
			'This is the description that shows when the user’s selected space does not have any available templates',
	},
});

const HandyTipLink = (
	<Button
		appearance="link"
		href="https://support.atlassian.com/confluence-cloud/docs/add-formatting-to-your-page/"
		// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
	>
		Check out these tips
	</Button>
);

export const EmptyTemplateList = injectIntl(
	class EmptyTemplateList extends PureComponent<WrappedComponentProps> {
		render() {
			return (
				<EmptyStateWrapper
					header={this.props.intl.formatMessage(i18n.header)}
					description={this.props.intl.formatMessage(i18n.description)}
					primaryAction={HandyTipLink}
					imageUrl={emptyImage}
					imageHeight={75}
				/>
			);
		}
	},
);
